<template>
    <v-content>
        <m-form ref="form_cadastro_externo">
            <v-card class="rounded pa-7 ma-6">
                <v-row class="mb-5">
                    <v-col cols="12" sm="4" class="d-flex justify-center">
                        <img v-if="logo" class="logo-menu-cadastro"
                             :src="logo"
                             alt="Logo Menu" />
                    </v-col>
                    <v-col cols="12" sm="4" class="d-flex align-center justify-center">
                        <h1 class="form-title">Cadastro de Usuário</h1>
                    </v-col>
                </v-row>
                <m-text-field label="CPF:" id="FieldCPF" class="required" disabled block filled maxlength="40"
                              :rules="[$rules.required]" v-model="formulario.cpf" />
                <m-text-field clearable label="Primeiro nome:" id="FieldName" class="required" maxlength="40"
                              v-input-filter="[$filters.text]" :rules="[$rules.required]" outlined v-model="formulario.nome" />
                <m-text-field label="Sobrenomes:" clearable id="FieldSobrenome" class="required" maxlength="80"
                              v-input-filter="[$filters.text]" :rules="[$rules.required]" outlined v-model="formulario.sobrenomes" />
                <v-row>
                    <v-col cols="12" md="6">
                        <DateField clearable label="Data de nascimento:" id="FieldDataNascimento" v-model="formulario.data_nascimento"
                                   :rules="[$rules.required, $rules.dataMaxima150]" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <Autocomplete label="Cidade de nascimento:" class="required" id="FieldCidadeNascimento"
                                      :rules="[$rules.required]"
                                      :items="cidades" url="/cidade/autocomplete"
                                      @input="setCidadeSelecionada" :return-object="true" v-model="cidade_selecionada"
                                      item-text="descricao" placeholder="Selecione uma cidade"
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-radio-group label="Sexo de nascimento:" id="GroupGenero" class="required" :rules="[$rules.required]"
                                       v-model="formulario.genero">
                            <v-row class="mt-2">
                                <v-col cols="6">
                                    <v-radio label="Masculino" id="RadioMasculino" value="M" />
                                </v-col>
                                <v-col cols="6">
                                    <v-radio label="Feminino" id="RadioFeminino" value="F" />
                                </v-col>
                            </v-row>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <m-text-field label="RG:" hint="Não é necessário colocar pontos e traços!" id="FieldRG" class="required"
                                      clearable v-validate-rg :rules="[$rules.required]" outlined maxlength="12"
                                      v-model="formulario.rg" type="text" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <DateField clearable label="Data de emissão do RG:" id="FieldDataEmissaoRg"
                                   v-model="formulario.data_emisssao_rg" :rules="[$rules.required, $rules.dataMaxima150]" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="6">
                        <m-text-field label="UF de emissão do RG:" id="FieldEstadoEmissaoRG" class="required" clearable maxlength="3"
                                      :rules="[$rules.required]" v-input-filter="[$filters.text]" outlined v-model="formulario.uf_emissao_rg" type="text" v-uppercase />
                    </v-col>
                    <v-col cols="12" md="6">
                        <m-text-field label="Celular:" id="FieldCelular" ref="celular" class="required" outlined
                                      v-model="formulario.telefone_celular" v-mask="'(##) #####-####'"
                                      :rules="[$rules.required, $rules.celular]" />
                    </v-col>
                </v-row>
                <m-text-field label="E-mail:" id="FieldEmail" class="required" outlined maxlength="80"
                              v-input-filter="[$filters.email]" v-model="formulario.email" :rules="[$rules.required, $rules.email]" />

                <v-row class="d-flex justify-start">
                </v-row>
            </v-card>
            <div class="d-flex justify-end">
                <v-btn class="mr-6" id="ButtonContinuar" color="primary" @click="enviaFormulario">
                    Solicitar cadastro
                </v-btn>
            </div>
        </m-form>
    </v-content>
</template>

<script>

  import { AlertTypes } from '@/plugins/alerts_types'
  import { DadosPadraoFormularioCadastroExterno } from '@/plugins/constants'
  import { notification, unmask } from '@/plugins/helpers'
  export default {
    name: 'FormularioCadastro',
    props: {
      cpf: { type: [Number, String], default: '' },
      nomeEmpresa: { type: [Number, String], default: '' },
      clientId: { type: [Number, String], default: '' },
      clientSecret: { type: [Number, String], default: '' },
      logo: { type: [Number, String], default: null }
    },
    data: () => ({
      formulario: {
        cpf: '',
        nome: '',
        sobrenomes: '',
        data_nascimento: '',
        genero: '',
        rg: '',
        id_cidade_nascimento: null,
        data_emisssao_rg: '',
        uf_emissao_rg: '',
        telefone_celular: '',
        email: ''
      },
      cidades: [],
      cidade_selecionada: null
    }),
    watch: {
      'formulario.id_cidade_nascimento': {
        immediate: true,
        handler (newVal) {
          if (newVal && (!this.cidade_selecionada || this.cidade_selecionada.id_cidade !== newVal)) {
            this.getCidade(newVal)
          }
        }
      }
    },
    mounted () {
      this.formulario.cpf = this.cpf
    },
    methods: {
      setCidadeSelecionada (value) {
        if (!value || !value.id_cidade) {
          this.formulario.id_cidade_nascimento = null
          return
        }
        this.formulario.id_cidade_nascimento = value.id_cidade || null
      },
      enviaFormulario () {
        const form = this.$refs.form_cadastro_externo
        if (form.validate()) {
          this.requisitaCadastroExterno()
        }
      },
      async requisitaCadastroExterno () {
        const payload = await this.montaPayloadCadastroExterno()
        this.$http.post('/CadastroExterno', payload,
                        {
                          auth: {
                            username: this.clientId,
                            password: this.clientSecret
                          },
                          headers: {
                            sistema: this.nomeEmpresa
                          }
                        }).then((response) => {
          this.$emit('sucesso')
        }).catch((error) => {
          console.error(error)
          this.$emit('falha')
        })
      },
      async montaPayloadCadastroExterno () {
        let payload = DadosPadraoFormularioCadastroExterno

        payload.dadosBase.cpf = unmask(this.cpf)
        payload.dadosBase.rg = this.formulario.rg
        payload.dadosBase.dataEmissaoRg = this.getDate(this.formulario.data_emisssao_rg)
        payload.dadosBase.estadoEmissor = this.formulario.uf_emissao_rg

        const cidadeEscolhida = await this.getCidade(this.formulario.id_cidade_nascimento)

        payload.dadosPessoa.nomeCompleto = this.formulario.nome + ' ' + this.formulario.sobrenomes
        payload.dadosPessoa.sexo = this.formulario.genero
        payload.dadosPessoa.telefone = unmask(this.formulario.telefone_celular)
        payload.dadosPessoa.email = this.formulario.email
        payload.dadosPessoa.nascimento = this.getDate(this.formulario.data_nascimento)
        payload.dadosPessoa.cidadeNascimento = cidadeEscolhida.data.nome
        payload.dadosPessoa.uf = cidadeEscolhida.data.uf

        return payload
      },
      getDate (date) {
        var partes = date.split('-')
        partes.reverse()
        return partes.join('')
      },
      async getCidade (id_cidade) {
        this.cidades = []
         try {
          const response = await this.$http.get('/cidade/' + id_cidade)
          this.cidades = [response.data]
          this.cidade_selecionada = { ...response.data }
          return response // Retornar a resposta para uso em montaPayloadCadastroExterno
        } catch (error) {
          this.cidade_selecionada = null
          notification(AlertTypes.WARN, 'Não foi possível buscar a cidade cadastrada')
          throw error // Propagar o erro para tratamento adequado
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
#ButtonContinuar {
  width: 170px;
  height: 45px;
  padding: 0 48px;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 36px;
  text-transform: capitalize;
  border-radius: 5px;
}

.rounded {
  border-radius: 6px !important;
}

.form-title {
  font-weight: 500;
  text-align: center;
}

.logo-menu-cadastro{
  width: 220px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

</style>
